module.exports = __webpack_public_path__ + "static/media/how_it_works_graph.a89599ec.gif";